import { render, staticRenderFns } from "./Angler.vue?vue&type=template&id=2d8eaf2e"
import script from "./Angler.vue?vue&type=script&lang=js"
export * from "./Angler.vue?vue&type=script&lang=js"
import style0 from "./Angler.vue?vue&type=style&index=0&id=2d8eaf2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports